import { valueActionCreator } from "../action_creators";

// add typeActionCreator for clear roles query, need a button to accomplish this in the search bar

export var ROLES_SET_QUERY = 'ROLES_SET_QUERY_ACTION';
export var rolesSetQueryAction = valueActionCreator(ROLES_SET_QUERY);